import React from 'react';
import CountUp, { startAnimation } from 'react-countup';
import Waypoint from 'react-waypoint';
import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './About.scss';

const START_TIME = 0;
const DURATION_TIME = 3;

const about = () => {
  let animationStarted = false;
  let days;
  let speakers;
  let presentations;
  let labs;
  let attendees;

  const startCounter = () => {
    if (!animationStarted) {
      startAnimation(days);
      startAnimation(speakers);
      startAnimation(presentations);
      startAnimation(labs);
      startAnimation(attendees);
      animationStarted = true;
    }
  };

  return (
    <section className="section" id="about">
      <div className="container">
        <h1 className="section-title about-title">ABOUT</h1>
        <div className="columns is-variable is-8 is-desktop is-multiline">
          <div className="column is-6-desktop is-12-tablet">
            <p>
              OpenSlava 2020 is the 8th edition of a successful conference for a broader IT
              community in Slovakia and abroad and one of the largest annual international
              conferences organized by <strong>Accenture in Central Europe</strong>.
            </p>
            <p>You should consider attending OpenSlava 2020 if you are:</p>
            <ul>
              <li>Technology architect or Developer</li>
              <li>IT consultant</li>
              <li>STEM university student or teacher </li>
              <li>
                Or simply an IT enthusiast interested in the latest trends in open source and
                emerging digital technologies
              </li>
            </ul>
            <p>
              As we want our OpenSlava community to further grow and keep it open for everyone, the
              registration to the conference will remain free of charge. Registration will open at
              the beginning of September, stay tuned.
            </p>
            <p>
              As OpenSlava is hosting inspirational speakers and participants from all around the
              globe, the language of the conference is English.
            </p>
            <p>
              Do you want to learn more about the organizer? Visit{' '}
              <a
                href="https://www.accenture.com/sk-sk/careers"
                rel="noopener noreferrer"
                target="_blank">
                {' '}
                www.accenture.sk
              </a>
              .
            </p>
            <p>NOT DECIDED YET WHETHER YOU SHOULD ATTEND? WATCH THE OPENSLAVA 2019 AFTERMOVIE.</p>
          </div>
          <div className="column is-hidden-touch is-6-desktop is-12-tablet" id="youtube-column">
            <LazyLoadTransition>
              <div className="background-layer card">
                <div className="card-image youtube-wrapper">
                  <iframe
                    allowFullScreen
                    frameBorder="0"
                    src="https://www.youtube.com/embed/j11Ax5dLSIU"
                    title="yt-video"
                    width="100%"
                  />
                </div>
                <footer className="footer-wrapper">
                  <strong>
                    <p className="card-footer-item">VIDEO RECORD FROM OPENSLAVA 2019</p>
                  </strong>
                </footer>
              </div>
            </LazyLoadTransition>
          </div>
        </div>

        <LazyLoadTransition>
          <h1 className="section-title openslava-numbers is-hidden-mobile">
            OPENSLAVA 2019 IN NUMBERS
          </h1>
          <Waypoint onEnter={startCounter} />
          <div className="columns is-variable is-8 is-desktop is-mobile is-multiline is-hidden-mobile">
            <div className="column is-2-desktop is-4-tablet is-offset-1-desktop single-stat">
              <div className="stat">
                <CountUp
                  ref={countUp => {
                    days = countUp;
                  }}
                  duration={DURATION_TIME}
                  end={2}
                  start={START_TIME}
                />
              </div>
              <div className="stat-info">Days</div>
            </div>
            <div className="column is-2-desktop is-4-tablet single-stat">
              <div className="stat">
                <CountUp
                  ref={countUp => {
                    speakers = countUp;
                  }}
                  duration={DURATION_TIME}
                  end={71}
                  start={START_TIME}
                />
              </div>
              <div className="stat-info">Speakers</div>
            </div>
            <div className="column is-2-desktop is-4-tablet single-stat">
              <div className="stat">
                <CountUp
                  ref={countUp => {
                    presentations = countUp;
                  }}
                  duration={DURATION_TIME}
                  end={40}
                  start={START_TIME}
                />
              </div>
              <div className="stat-info">Presentations</div>
            </div>
            <div className="column is-2-desktop is-6-tablet single-stat">
              <div className="stat">
                <CountUp
                  ref={countUp => {
                    labs = countUp;
                  }}
                  duration={DURATION_TIME}
                  end={16}
                  start={START_TIME}
                />
              </div>
              <div className="stat-info">Hands-on Labs</div>
            </div>
            <div className="column is-2-desktop is-6-tablet single-stat">
              <div className="stat">
                <CountUp
                  ref={countUp => {
                    attendees = countUp;
                  }}
                  duration={DURATION_TIME}
                  end={1289}
                  start={START_TIME}
                />
              </div>
              <div className="stat-info">Attendees</div>
            </div>
          </div>
        </LazyLoadTransition>
      </div>
    </section>
  );
};

export default about;
